import { render } from "./TheRestartOverlay.vue?vue&type=template&id=48e58d82&scoped=true"
import script from "./TheRestartOverlay.vue?vue&type=script&lang=js"
export * from "./TheRestartOverlay.vue?vue&type=script&lang=js"

import "./TheRestartOverlay.vue?vue&type=style&index=0&id=48e58d82&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e58d82"]])

export default __exports__